import { compose, defaultProps, pure } from "react-recompose";
import { telenorTextColor } from "themes/colors";

export default compose(pure, defaultProps({ nativeColor: telenorTextColor }));
